type StatboardProps = {
    label: string
    value: number
    subLabel?: string
    backgroundColor: string
    color?: string
}

export const StatsCard = (props: StatboardProps)=>{

    return(
        <div className='flex-column card card-stats' style={{backgroundColor: props.backgroundColor, color: props.color }} >
            <h1 style={{minWidth: 50, textAlign:'center'}} >{props.value}</h1>
            <h4 style={{position:'absolute', bottom: 10, left: 10}} >{props.label}</h4>
        </div>
    )
}